import styled from "styled-components"
export const ProjectInfo = styled.article`
  width: 100%;
  max-width: 960px;
  padding: 10px 0 50px 0;
  margin: 0 auto;
  > h2 {
    font-weight: 400;
    font-family: "Velo Sans Display Light It";
  }
  @media (max-width: 1000px) {
    max-width: 640px;
  }
`
